export const PREFERRED_OPTION = 'preferred';
export const EXCLUSIVE_OPTION = 'exclusive';
